// Spec iter131 (Feb 2026) — Pastilles de priorité harmonisées. Trois
// niveaux visibles : Normal · Élevée · Immédiat (le legacy "Faible" est
// retiré côté UI ; les tâches historiques stockées avec `priority=normal`
// sont désormais affichées comme « Normal » pour compatibilité).
//
// Style unique : icône colorée + texte même couleur, sans fond ni
// bordure, font-weight 600, texte 13 px, icône 15 px.
import { Minus, ArrowUp, Flame } from "lucide-react";

const MAP = {
  // Spec iter132 (Feb 2026) — 3 niveaux uniquement. Alias legacy retiré
  // après migration DB (168 tâches `normal` → `moyen`).
  moyen:    { label: "Normal",   color: "#22C55E", Icon: Minus },
  urgent:   { label: "Élevée",   color: "#F97316", Icon: ArrowUp },
  immediat: { label: "Immédiat", color: "#EF4444", Icon: Flame },
};

// Choix proposés dans les formulaires (sans « Faible » / normal).
export const PRIORITY_KEYS = ["moyen", "urgent", "immediat"];

export default function PriorityBadge({ priority, size = "sm", iconOnly = false }) {
  const p = MAP[priority] || MAP.moyen;
  const Icon = p.Icon;
  const iconSize = size === "lg" ? 18 : 15;
  const fontSize = size === "lg" ? 15 : 13;
  return (
    <span
      className="inline-flex items-center gap-1.5 whitespace-nowrap"
      style={{
        color: p.color,
        fontWeight: 600,
        fontSize,
        lineHeight: 1.1,
      }}
      data-testid={`priority-badge-${priority}`}
    >
      <Icon size={iconSize} strokeWidth={2.2} />
      {!iconOnly && <span>{p.label}</span>}
    </span>
  );
}

export const PRIORITY_LABEL = Object.fromEntries(Object.entries(MAP).map(([k, v]) => [k, v.label]));
export const PRIORITY_COLOR = Object.fromEntries(Object.entries(MAP).map(([k, v]) => [k, v.color]));
